import { useEffect, useState } from "react";

import { getHousekeepingProtocol } from "api/housekeeping-protocols";
import HousekeepingProtocolForm from "./HousekeepingProtocolForm";

function HousekeepingProtocolFormWrapper({
  protocolId,
  report,
  handleClose,
  handleConfirm,
  handleDelete,
  hideActions = false,
}) {
  const [protocol, setProtocol] = useState(null);

  useEffect(() => {
    // The last loaded protocol is kept when closing so the drawer doesn't empty while it slides out
    if (!protocolId) {
      return;
    }

    // Opening a protocol: show the drawer right away with a loading state, then fill it
    let cancelled = false;
    setProtocol(null);
    getHousekeepingProtocol(protocolId)
      .then((protocol) => !cancelled && setProtocol(protocol))
      .catch(() => {
        if (!cancelled) {
          alert("Failed to load housekeeping protocol");
          handleClose();
        }
      });

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [protocolId]);

  return (
    <HousekeepingProtocolForm
      open={Boolean(protocolId)}
      loading={Boolean(protocolId) && !protocol}
      protocol={protocol || {}}
      report={report}
      handleClose={handleClose}
      handleConfirm={handleConfirm}
      handleDelete={handleDelete}
      hideActions={hideActions}
    />
  );
}

export default HousekeepingProtocolFormWrapper;
